import MarkdownIt from 'markdown-it';
import taskLists from 'markdown-it-task-lists';

const markdown = new MarkdownIt({
  breaks: true,
  html: false,
  linkify: true,
  typographer: false
});

markdown.use(taskLists, { enabled: false, label: true, labelAfter: true });

const defaultLinkOpen = markdown.renderer.rules.link_open
  || ((tokens, index, options, env, renderer) => renderer.renderToken(tokens, index, options));

markdown.renderer.rules.link_open = (tokens, index, options, env, renderer) => {
  const token = tokens[index];
  token.attrSet('target', '_blank');
  token.attrSet('rel', 'noopener noreferrer');
  return defaultLinkOpen(tokens, index, options, env, renderer);
};

const defaultImage = markdown.renderer.rules.image;
markdown.renderer.rules.image = (tokens, index, options, env, renderer) => {
  tokens[index].attrSet('loading', 'lazy');
  tokens[index].attrSet('referrerpolicy', 'no-referrer');
  return defaultImage(tokens, index, options, env, renderer);
};

/**
 * 将开放接口文档 Markdown 渲染为安全 HTML。
 * HTML 解析保持关闭，原始标签会被转义；链接协议也会由 markdown-it 内置校验器过滤。
 */
export const renderMarkdown = value => value ? markdown.render(String(value)) : '';
